import { Typography } from "@mui/material";

const directorEmployeeColumnProperty = {
  key: "directorEmployee",
  label: "担当",
  align: "right",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "20mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
};

const arrivalDateColumnProperty = {
  key: "arrivalDate",
  label: "入荷日付",
  align: "left",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "40mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
};

const commodityOwnerCdHyphenedColumnProperty = {
  key: "commodityOwnerCdHyphened",
  label: "荷主CD",
  align: "left",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "37mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
};

const commodityOwnerNameColumnProperty = {
  key: "commodityOwnerName",
  label: "荷主名",
  align: "left",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "70mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
};

const productIdColumnProperty = {
  key: "productId",
  label: "商品ID",
  align: "left",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "29mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
};

const productNameColumnProperty = {
  key: "productName",
  label: "商品名",
  align: "left",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "70mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
};

const salesRecordNoColumnProperty = {
  key: "salesRecordNo",
  label: "販売原票",
  align: "left",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "34mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
};

const acceptanceLabelNoColumnProperty = {
  key: "acceptanceLabelNo",
  label: "送り状No",
  align: "right",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "29mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
};

const partitionColumnProperty = {
  key: "partition",
  label: "仕切",
  align: "right",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "19mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
};

const salesDetailNoColumnProperty = {
  key: "salesDetailNo",
  label: "順",
  align: "right",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "9mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
};

const rankNameColumnProperty = {
  key: "rankName",
  label: "等級",
  align: "left",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "27mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
};

const productClassNameColumnProperty = {
  key: "productClassName",
  label: "階級",
  align: "left",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "27mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
};

const purchasePriceColumnProperty = {
  key: "displayPurchasePrice",
  label: "仕入",
  align: "right",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "33mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
};

const stockAmountColumnProperty = {
  key: "displayStockAmount",
  label: "在庫数",
  align: "right",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "27mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
};
const totalPurchasePriceColumnProperty = {
  key: "displayTotalPurchasePrice",
  label: "在庫金額",
  align: "right",
  // isGroup: true,
  dataKey: "index",
  cellProps: {
    width: "35mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
}

export const selectedNotShowableColumnProperty = {
  key: "selectedNotShowable",
  label: "非表示",
  align: "center",
  // isGroup: true,
  dataKey: "selectedNotShowable",
  cellProps: {
    width: "35mm",
    rowCell: {
      borderRight: "1px solid #e0e0e0",
    },
  },
  render: (item) => (
    item.isAvailableStock
      ? null
      : <Typography color='red'>非表示</Typography>
  )
}

const STAFF_STOCK_TABLE_COLUMN_PROPERTIES = [
  directorEmployeeColumnProperty,
  arrivalDateColumnProperty,
  commodityOwnerCdHyphenedColumnProperty,
  commodityOwnerNameColumnProperty,
  productIdColumnProperty,
  productNameColumnProperty,
  salesRecordNoColumnProperty,
  acceptanceLabelNoColumnProperty,
  partitionColumnProperty,
  salesDetailNoColumnProperty,
  rankNameColumnProperty,
  productClassNameColumnProperty,
  purchasePriceColumnProperty,
  stockAmountColumnProperty,
  totalPurchasePriceColumnProperty,
  selectedNotShowableColumnProperty
];

export default STAFF_STOCK_TABLE_COLUMN_PROPERTIES;